var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CookiesBanner", { class: [_vm.themeClass] }),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$store.state.sharedDialog.content,
          okFn: _vm.$store.state.sharedDialog.okFn,
          okBtnText: _vm.$store.state.sharedDialog.okBtnText,
          size: _vm.$store.state.sharedDialog.size
        },
        model: {
          value: _vm.sharedDialogVisible,
          callback: function($$v) {
            _vm.sharedDialogVisible = $$v
          },
          expression: "sharedDialogVisible"
        }
      }),
      _vm._v(" "),
      _c(_vm.layoutType, {
        tag: "component",
        class: [_vm.themeClass, { "forum-class": _vm.$route.meta.forumClass }]
      }),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b2b435e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2b435e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/BaseLayout.vue
// module id = 1748
// module chunks = 117